// HR-1 — historical expenditure control (display-only reconciliation; never writes to invoices, ETC or forecasts)
import { supabase } from '@/lib/supabase';
import { isMissingObject } from '@/lib/schemaReady';

const q = async (p) => { const { data, error } = await p; if (error) throw error; return data; };

export const getHistoricalReconciliation = async (projectId) => {
  try { return await q(supabase.from('v_project_historical_reconciliation').select('*').eq('project_id', projectId).maybeSingle()); }
  catch (e) { if (isMissingObject(e)) return null; throw e; }
};
export const saveHistoricalControl = (row) => q(supabase.from('project_historical_controls').upsert(row, { onConflict: 'project_id' }).select().single());
export const BASIS_LABEL = { gross_unconfirmed: 'incl. VAT — VAT basis unconfirmed', net_confirmed: 'ex VAT — confirmed', gross_confirmed: 'incl. VAT — confirmed' };
